import React from 'react';
import styled from "styled-components"

const OverlayImageModal = (props) => {
const {imagePath} = props;

const handleClick = () => {
  props.overlayImageToggle(imagePath);
}
let path=null;
if(imagePath.includes("#RBLIMG#")){
  path=imagePath.split("#RBLIMG#")[1];
}else if(imagePath.includes("#WithOutQuotesPath#")){
  let with_quotes=imagePath.split("src=")[1].split(" ")[0];
  path=with_quotes.substring(0,with_quotes.length);
}else{
  let with_quotes=imagePath.split("src=")[1].split(" ")[0];
  path=with_quotes.substring(1,with_quotes.length-1);
}
    return (
      <OverlayBlock>
        <MessageBlock>
        <CloseButton className="close" onClick={() => handleClick()}>&times;</CloseButton>
            <Message src={path} alt="image not loaded"/>
        </MessageBlock>
      </OverlayBlock>
    );
}

const OverlayBlock=styled.div`
  height: 100%;
  width:100%;
  position:absolute;
  background:rgba(0,0,0,0.2);
  z-index: 100;
`
const MessageBlock=styled.div`
  position:absolute;
  top: 50%;
  left: 50%;
  width: 90%;
  transform: translate(-50%,-50%);
  padding: 30px 0px;
  box-sizing: border-box;
  border-radius: 8px;
  background: #ffffff;

`

const Message=styled.img`
  width: 100%;
`
const CloseButton=styled.span`
    position: absolute;
    top: 0px;
    right: 10px;
    color: green;
    font-size: 30px;
    font-weight: bold;
    transition: 0.3s;
    &:hover,:focus{
    color: red;
    text-decoration: none;
    cursor: pointer;
    }
`


export default OverlayImageModal;